import { render, staticRenderFns } from "./GalleryDashboardCard.vue?vue&type=template&id=77ea4d46"
import script from "./GalleryDashboardCard.vue?vue&type=script&lang=ts"
export * from "./GalleryDashboardCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports